/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingParallelSlotsQueryResponse, GetApiBookingParallelSlotsQueryParams } from "../entities/GetApiBookingParallelSlots";

function getGetApiBookingParallelSlotsUrl() {
  const res = { method: 'GET', url: `/api/booking/parallel/slots` as const }
  return res
}

/**
 * @description Возвращает комбинации времени и двух мастеров, доступных одновременно
 * @summary Получить доступные слоты для параллельной записи
 * {@link /api/booking/parallel/slots}
 */
export async function getApiBookingParallelSlots(params: GetApiBookingParallelSlotsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBookingParallelSlotsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetApiBookingParallelSlotsUrl().url.toString(), params, ... requestConfig })
  return res.data
}